import locationTrackingMap from "./locationTrackingMap.component";

const locationTrackingMapModule = angular
  .module("app.components.locationTrackingMap", [])
  .component("locationTrackingMap", locationTrackingMap);

export default locationTrackingMapModule;



// WEBPACK FOOTER //
// ./src/components/locationTrackingMap/locationTrackingMap.module.js